import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'

const schema = z.object({
  name: z.string().min(1),
})

export type RenameCollectionFormValues = z.infer<typeof schema>

export const RENAME_COLLECTION_FORM_ID = 'rename-collection-form'
export const renameCollectionFormResolver = zodResolver(schema)
